module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-07@2x.5f9946f6.jpg";